"use client";

import { useEffect, useRef } from "react";

import { useJuneSoEventTracking } from "@stadium/services/june-analytics/hooks/use-june-so-event-tracking";

import { WIDGET_SERVICES } from "@constants/june-so";

const emptyObj = {};

const TextOnlyWidgetClient = ({ data, editingAllowed, children }) => {
  const { jsonContent } = data;
  const { rte_content = "" } = JSON.parse(jsonContent) ?? emptyObj;
  const { trackEvent } = useJuneSoEventTracking({ services: WIDGET_SERVICES });

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      container.addEventListener("click", (e) => {
        if (e?.target?.dataset?.track) {
          trackEvent({
            componentName: e.target.dataset.track,
            ...(e.target.dataset.action ? { action: e.target.dataset.action } : {}),
          });
        }
      });
    }

    return () => {
      if (container) {
        container.removeEventListener("click", () => {});
      }
    };
  }, []);

  if (rte_content) {
    return (
      <>
        <div ref={containerRef} dangerouslySetInnerHTML={{ __html: rte_content }} />
        {editingAllowed && children}
      </>
    );
  }
  return null;
};

export default TextOnlyWidgetClient;
